import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import classnames from 'classnames2';
import { kebabCase } from 'lodash';
import React from 'react';
import styles from './Select.Option.scss';
export var SelectOption = function SelectOption(props) {
  var _classnames;

  var optionClasses = classnames(styles.option, styles["indentation".concat(props.indentLevel)], (_classnames = {}, _defineProperty(_classnames, styles.optionSelected, props.selected), _defineProperty(_classnames, styles.optionDisabled, props.disabled), _defineProperty(_classnames, styles.descriptionPresent, props.description), _classnames));
  return React.createElement("div", {
    className: classnames(styles.listItem, _defineProperty({}, styles.optionDisabled, props.disabled)),
    "data-test": props.dataTest,
    onClick: props.disabled ? null : function () {
      return props.onClick(props.value);
    },
    onMouseOver: props.disabled && props.onHover != null ? null : function () {
      return props.onHover(props.value);
    },
    role: "listitem"
  }, React.createElement("div", {
    className: optionClasses,
    "data-test": "select-option-text-".concat(kebabCase(props.label))
  }, props.prefixIcon && React.createElement("div", {
    className: styles.iconWrapper
  }, props.prefixIcon), React.createElement("div", {
    className: styles.labelsContainer
  }, React.createElement("div", {
    className: styles.flexContainer
  }, React.createElement("div", {
    className: styles.primary,
    "data-test": "select-option-primary-text-".concat(kebabCase(props.label))
  }, props.children || props.label), props.secondaryLabel ? React.createElement("div", {
    className: classnames(styles.secondary, _defineProperty({}, styles.optionDisabled, props.disabled)),
    "data-test": "select-option-secondary-text-".concat(kebabCase(props.secondaryLabel))
  }, props.secondaryLabel) : null), props.description ? React.createElement("div", {
    className: styles.description,
    "data-test": "select-option-description-text-".concat(kebabCase(props.description))
  }, props.description) : null)));
};
SelectOption.defaultProps = {
  indentLevel: 0,
  onClick: function onClick() {},
  onHover: function onHover() {}
};